/**
* Enables Visual Editing overlay in a page with sourcemap encoding.
*
* This will overlay UI on hovered elements that deep-links to Sanity Studio.
* @public
*/
function enableVisualEditing(options = {}) {
	let controller = new AbortController();
	return import("./renderVisualEditing-Dx077Iuu.js").then(({ renderVisualEditing }) => {
		let { signal } = controller;
		signal.aborted || renderVisualEditing(signal, options);
	}), () => {
		controller.abort();
	};
}
export { enableVisualEditing as t };

//# sourceMappingURL=enableVisualEditing-CwMctsW3.js.map